// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3nKcZ","checkboxCol":"Table_checkboxCol__248Fb","emailCol":"Table_emailCol__35w1X","actionCol":"Table_actionCol__2bjGn"};